import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { userService } from '../services/userService';
import type { UpdateUserDto } from '../types';

export function useUpdateUser() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('users');

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateUserDto }) =>
      userService.updateUser(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success({ title: t('toasts.updateSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.updateError') });
    },
  });
}
